import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/Common";
import { ContactRegistration } from "@/components/ContactRegistration";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Headphones, CheckCircle2, MessageCircle, Phone, RotateCcw } from "lucide-react";

const Centralino = () => {
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [key, setKey] = useState(0);

  if (result) {
    const wa = (result.responsabile_whatsapp || "").replace(/[^0-9]/g, "");
    const msg = encodeURIComponent(`Buongiorno, la contattiamo dalla Rete Azioni Solidali per la pratica ${result.numero_pratica || ""}. La ricontatteremo a breve.`);
    return (
      <div className="max-w-2xl mx-auto">
        <Card className="p-8 text-center">
          <div className="h-16 w-16 rounded-full bg-[color:var(--brand-green-100)] flex items-center justify-center mx-auto"><CheckCircle2 className="h-9 w-9 text-[color:var(--brand-green-700)]" /></div>
          <h2 className="font-display text-2xl font-semibold mt-4">Contatto registrato</h2>
          {result.numero_pratica && <p className="font-display text-3xl font-bold text-[color:var(--brand-blue-700)] mt-3" data-testid="centralino-result-number">{result.numero_pratica}</p>}
          <p className="text-sm text-muted-foreground mt-2">Responsabile: <span className="font-medium">{result.responsabile_nome || "-"}</span>{result.attivita_creata ? " · Attività di richiamo creata" : ""}</p>
          <div className="flex flex-wrap justify-center gap-2 mt-5">
            {wa && <a href={`https://wa.me/${wa}?text=${msg}`} target="_blank" rel="noreferrer"><Button variant="outline" className="text-[color:var(--brand-green-700)]"><MessageCircle className="h-4 w-4 mr-2" /> Messaggio di presa in carico (WhatsApp)</Button></a>}
            {result.case_id && <Button onClick={() => navigate(`/app/pratiche/${result.case_id}`)}>Apri la pratica</Button>}
            <Button variant="secondary" onClick={() => { setResult(null); setKey((k) => k + 1); }}><RotateCcw className="h-4 w-4 mr-2" /> Nuovo contatto</Button>
          </div>
          <p className="text-[11px] text-muted-foreground mt-4">Invio WhatsApp/SMS automatico: predisposto ma non ancora configurato. Usa il pulsante per aprire WhatsApp con testo precompilato.</p>
        </Card>
      </div>
    );
  }

  return (
    <div>
      <PageHeader icon={Headphones} title="Modalità Centralino" description="Registra il contatto durante la telefonata e descrivi in dettaglio la situazione in ingresso." />
      <div className="max-w-3xl"><ContactRegistration key={key} onDone={setResult} big /></div>
    </div>
  );
};

export default Centralino;
